import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalooManualSyncComponent } from './baloo-manual-sync.component';
import { FiAppTextSharedModule } from '../../../shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { BalooSyncLogModule } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log.module';
import { FiMatTabGroupBookmarkLayoutModule } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-group-bookmark-layout.module';
import { FiAutocompleteItemsModule } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatCardModule,
        MatTabsModule,
        BalooSyncLogModule,
        FiMatTabGroupBookmarkLayoutModule,
        FiAutocompleteItemsModule,
    ],
    declarations: [BalooManualSyncComponent],
})
export class BalooManualSyncModule {}
